import * as React from "react"
import { Box, Typography } from "@mui/material"

import { NotAllowedBlock } from "@components"

export default function sellerColumn() {
	return {
		name: 'sellerName', label: 'Seller Name',
		options: {
            filter: false,
			customBodyRowRenderLite: (value, row) => {
                return <Box sx={{ alignItems: 'center' }}>
                    {!!row.wonBuyBox && <Typography>{value}</Typography>}
                    {!row.wonBuyBox && <NotAllowedBlock sx={{ fontWeight: 'bold'}} />}
                </Box>
            }
		}
	}
}